export default class AlMergeTagSelectorController {

    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;
        this.api = this.injector.get('$http');

        this.formModels = {
            guestlist_id: 'non-guestlist',
            field_group: null,
            field: null,
            preview_entity_id: null,
            rendered_preview: ''
        };

        this.guestlistId = -1;
        this.scopedGuestlists = [];
        this.hideNonGuestlist = false;
        this.entityPrefix = 'templates';
        this.showPreview = true;


        this.previewEntitySelectorConfig = null;
        this.availablePlaceholders = null;
        this.loading = true;
        this.availableGuestlists = [];
    }

    triggerPlaceholderSelect() {
        this.onPlaceholderSelect({
            selectedPlaceholder: _.cloneDeep(this.formModels.field)
        })
    }

    $onInit() {
        this._initWatchers();

        this._initFormStores();
        this._loadAvailableGuestlists().then(
            () => {
                this.loading = false;
                this.scope.$applyAsync();
            }
        );
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.guestlistId;
        }, () => {
            this.formModels.guestlist_id = this.guestlistId || 'non-guestlist';
            this.formModels.preview_entity_id = null;
            this._initFormStores();
        });


        this.scope.$watch(() => {
            return this.formModels.guestlist_id;
        }, () => {
            this.formModels.preview_entity_id = null;
            this._loadAvailablePlaceholders();
            this._initFormStores();
        });

        this.scope.$watch(() => {
            return this.formModels.field_group;
        }, () => {
            this.formModels.field = _.first(_.get(this.formModels.field_group, 'fields', [])) || null;
        });

        this.scope.$watch(() => {
            return this.formModels.preview_entity_id;
        }, () => {
            this._loadPreviewForEntity();
        });

        this.scope.$watch(() => {
            return this.formModels.field;
        }, () => {
            this._loadPreviewForEntity();
            this.triggerPlaceholderSelect();
        });
    }

    _initFormStores() {
        this.previewEntitySelectorConfig = null;

        this.injector.get('$timeout')(() => {
            if (this.formModels.guestlist_id !== 'non-guestlist') {
                this.previewEntitySelectorConfig = {
                    store: this.injector.get('Rsvps').create('TemplatePlaceholderPreviewRsvpListView').reset({
                        persist: false,
                        listview: 'TemplatePlaceholderPreviewRsvpListView',
                        permanentFilters: {
                            guestlist_id: this.formModels.guestlist_id
                        },
                        columns: [
                            {
                                key: 'id',
                                type: 'integer',
                                visible: true
                            },
                            {
                                key: 'guestlist_id',
                                type: 'integer',
                                visible: true
                            },
                            {
                                key: 'contact.full_name',
                                type: 'string',
                                visible: true
                            }
                        ]
                    }),
                    displayField: 'contact.full_name',
                    valueField: 'id',
                };
            } else {
                this.previewEntitySelectorConfig = {
                    store: this.injector.get('Contacts').reset({
                        persist: false,
                        listview: 'TemplatePlaceholderPreviewContactListView'
                    }),
                    columns: [
                        {
                            key: 'id',
                            type: 'integer',
                            visible: true
                        },
                        {
                            key: 'full_name',
                            type: 'string',
                            visible: true
                        }
                    ],
                    displayField: 'full_name',
                    valueField: 'id',
                };
            }
        }, 0);
    }

    _loadAvailableGuestlists() {
        const guestlistStore = this.injector.get('Guestlists').reset({
            persist: false,
            listview: 'TemplatePreviewGuestlistSelector',
            permanentFilters: (() => {
                const out = {};

                if (this.scopedGuestlists.length > 0) {
                    out.id = this.scopedGuestlists.join(' OR ');
                }

                return out;
            })()
        });

        guestlistStore.commit('setColumns', [
            {
                key: 'id',
                type: 'integer',
                visible: true
            },
            {
                key: 'name',
                type: 'string',
                visible: true
            }
        ]);

        guestlistStore.dispatch('setPageSize', -1);

        return guestlistStore.dispatch('getData')
            .then(() => {
                    this.availableGuestlists = [];

                    if (!this.hideNonGuestlist) {
                        this.availableGuestlists.push({
                            id: 'non-guestlist',
                            name: 'No guest list (Contacts only) '
                        });
                    }

                    _.each(guestlistStore.state.data, (row) => {
                        this.availableGuestlists.push({
                            id: row.id,
                            name: row.name
                        });
                    });

                    if (this.hideNonGuestlist) {
                        this.formModels.guestlist_id = _.get(_.first(this.availableGuestlists), 'id');
                    }

                    this.scope.$applyAsync();
                }
            );
    }

    _loadAvailablePlaceholders() {
        let placeholderUrl = `${this.entityPrefix}/placeholders`;

        if (this.formModels.guestlist_id !== 'non-guestlist') {
            if (!this.formModels.guestlist_id) {
                return;
            }

            placeholderUrl = `${this.entityPrefix}/guestlists/${this.formModels.guestlist_id}/placeholders`;
        } else if (this.hideNonGuestlist) {
            return;
        }

        this.api
            .get(placeholderUrl)
            .then((responseData) => {
                this.availablePlaceholders = _.get(responseData.data, 'data', null);

                this.formModels.field_group = _.first(this.availablePlaceholders) || null;
            })
            .catch((response) => {

            });
    }

    _loadPreviewForEntity() {
        this.formModels.rendered_preview = '';
        const previewContent = _.get(this.formModels, 'field.placeholder', '');

        if (!previewContent || !this.formModels.preview_entity_id || !this.formModels) {
            return;
        }

        let previewUrl = `${this.entityPrefix}/placeholders/contacts/${this.formModels.preview_entity_id}/preview`;

        if (this.formModels.guestlist_id !== 'non-guestlist') {
            previewUrl = `${this.entityPrefix}/placeholders/rsvps/${this.formModels.preview_entity_id}/preview`;
        }

        this.api
            .post(previewUrl, {
                'preview_content': previewContent
            })
            .then((responseData) => {
                this.formModels.rendered_preview = _.get(responseData.data, 'data.rendered_preview', null);
            })
            .catch((response) => {

            });
    }
}

AlMergeTagSelectorController.$inject = [
    '$scope',
    '$injector'
];



// WEBPACK FOOTER //
// ./src/app/modules/merge-tags/components/al-merge-tags-selector/controller.js